// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/ArrowLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowLeftOutlinedSvg
  }));
};

ArrowLeftOutlined.displayName = 'ArrowLeftOutlined';
export default React.forwardRef(ArrowLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ArrowLeftOutlined.js
// module id = 595
// module chunks = 0